import { render, staticRenderFns } from "./PictureField.vue?vue&type=template&id=80ebf87a&scoped=true"
import script from "./PictureField.vue?vue&type=script&lang=js"
export * from "./PictureField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ebf87a",
  null
  
)

export default component.exports